export async function saveTeamRegistration({
  token,
  stageId,
  userId,
  themeName,
  maxTeams,
  team_number,
  team_name,
  captain_name,
  war_cry,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/saveTeamRegistration`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ stageId, userId, themeName, maxTeams, team_number, team_name, captain_name, war_cry }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || "Failed to save team registration");
  // `full` is a normal outcome the caller needs to distinguish from a hard failure — don't throw.
  if (data && data.success === false && !data.full) {
    throw new Error(data.message || "Failed to save team registration");
  }
  return data;
}
